/*
 * Copyright (c) 2020 SQUAREPING INC.
 *
 * SQUAREPING CONFIDENTIAL
 * [2019 and Beyond] SQUAREPING INC. All Rights Reserved.
 *
 * NOTICE: The source code contained herein is, and remains the property of SQUAREPING INC.
 * and its suppliers, if any. The intellectual and technical concepts contained herein are
 * proprietary to SQUAREPING INC. and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material is strictly forbidden
 * anywhere in the world unless prior written permission is obtained from SQUAREPING INC.
 */

import { Form, FormItemProps } from 'antd';
import React from 'react';
import css from './FormItem.module.css';
import classNames from 'classnames';

type Props = FormItemProps & {
  noMarginTop?: boolean;
};

const defaultStyle: any = {
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  flexDirection: 'row', // to allow children expand with flex:1
  justifyContent: 'stretch',
};

export const FormItem = (props: Props) => {
  const { validateTrigger = 'onChange', children, style, className, noMarginTop = false, ...rest } = props;
  //const isRequired = rest?.rules?.[0]?.required === true;
  return (
    <div style={style} className={classNames(css.container, className, noMarginTop && css.noMarginTop)}>
      <Form.Item {...rest} style={defaultStyle} validateTrigger={validateTrigger}>
        {children}
      </Form.Item>
    </div>
  );
};
